import { Routes, Route } from 'react-router-dom';
import DashboardNavbar from './dashboard_nav/DashboardNavbar';
import AccountManagement from '../Account/Account_management';
import CustomerManagement from '../Customer/Customer_management';
import SupplierManagement from '../Supplier/Supplier_Management';
import BillingPanel from '../Billing_panel/Billing_panel_monitor';
import InventoryPanel from '../Inventory/Inventory';
import Administration from '../Shop_Admin/Administration';
import Dashboard_home from './Dashboard_home'
import Setting from '../Setting/Setting';

const DashboardLayout = () => {
  return (
    <>
    <DashboardNavbar/>

      {/* Main Content */}
      <div className="dashboard-content">
        <Routes>
        <Route path="/" element={<Dashboard_home />} />
        <Route path="/Dashboard_panel" element={<DashboardNavbar />} />
          <Route path="/account_panel" element={<AccountManagement />} />
          <Route path="/customers_panel" element={<CustomerManagement />} />
          <Route path="/suppliers_panel" element={<SupplierManagement />} />
          <Route path="/billing_panel" element={<BillingPanel />} />
          <Route path="/inventory_panel" element={<InventoryPanel />} />
          <Route path="/admin_panel" element={<Administration />} />
          <Route path="/admin_panel" element={<Administration />} />
          <Route path="/setting_panel" element={<Setting />} />
        </Routes>
      </div>
    </>
  );
};

export default DashboardLayout;
